import { useEffect, useRef, useState } from 'react'
import ResizeObserver from 'resize-observer-polyfill'

export default function useElementResize() {
  const [width, setWidth] = useState(null)
  const [height, setHeight] = useState(null)

  const ref = useRef(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const handleRefResize = () => {
      setWidth(element.clientWidth)
      setHeight(element.clientHeight)
    }

    const observer = new ResizeObserver(handleRefResize)
    observer.observe(element)
    handleRefResize()

    return () => {
      observer.unobserve(element)
    }
  }, [ref])

  return { ref, width, height }
}
